import React from 'react'
import { SurgicalPendencyList } from 'presentation/doctor/components/SurgicalPendencyList'

export function PatientPendencies() {
  return <SurgicalPendencyList />
}
